<template>
  <section
    class="flex w-full items-stretch"
    data-test="pickup-call-item"
  >
    <div class="flex min-w-0 flex-1 flex-col justify-center gap-1 py-3 pl-4">
      <div class="flex min-w-0 items-center gap-1">
        <contact-avatar
          class="shrink-0"
          :contact="targetContact"
          :name="targetName"
          :size="24"
        />
        <p class="min-w-0 truncate text-body-m-15-22 text-fg-base-fg3">
          {{ targetName }}
        </p>
      </div>
      <div class="flex min-w-0 items-center">
        <span class="shrink-0 text-label-r-13-18 text-fg-base-fg14">
          {{ $t('mainAside.incomingFrom') }}
        </span>
        <div class="flex min-w-0 items-center gap-1 pl-1.5">
          <span class="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-bg-base-bg6">
            <wui-icon
              name="phoneM"
              class="h-3! w-3! text-fg-base-fg22"
            />
          </span>
          <p class="min-w-0 truncate text-body-m-15-22 text-fg-base-fg3">
            {{ fromName }}
          </p>
        </div>
      </div>
    </div>
    <div class="flex shrink-0 items-center justify-center self-stretch gap-1.5 py-0 pl-2 pr-3">
      <slot name="action" />
    </div>
  </section>
</template>

<script setup lang="ts">
import { WuiIcon } from '@wui/common-library'
import { computed } from 'vue'

import { useStoreContacts } from '@/entities/contact'
import { ContactAvatar } from '@/entities/contact-avatar'

import { CallNotificationValue } from '@/shared/composables/calls-notifications'

const props = defineProps<{
  notification: CallNotificationValue
}>()

const { findByInternalNumber } = useStoreContacts()

const event = computed(() => props.notification.eventData)

const targetName = computed(() => event.value.targetName || event.value.target)
const fromName = computed(() => event.value.fromName || event.value.from)

const targetContact = computed(() => findByInternalNumber(event.value.target))
</script>
